import Container from 'components/container';
import Link from 'next/link';
import { LIBUM_KEYWORDS, LIBUM_URL } from 'shared/constants/globals';
import { ContentHeadline, ContentMain, ContentPanel } from 'shared/styles/components';
import {
  ProductsContainer,
  ProductsGrid,
  ProductCardWrapper,
  ProductCard,
  ProductCardHeader,
  ProductCardBody,
} from './products.styles';

export default function Products() {
  const title = 'Products | Libum';
  const description =
    "Explore Libum's suite of products: PowerOn Pipelines for CI/CD, PowerOn Pro for development, NexumAPI for integrations, and Glaci for analytics.";
  const keywords = LIBUM_KEYWORDS;
  const url = `${LIBUM_URL}/products`;

  const products = [
    {
      id: 'glaci',
      name: 'Glaci',
      tagline: 'Core Enablement',
      description:
        'Enhance your credit union operations with custom playbooks, real-time opportunities, revamped work areas, and intelligent analytics through an overlay in Quest.',
      href: '/glaci',
      status: 'In Development',
      releaseYear: 2026,
    },
    {
      id: 'poweron-pipelines',
      name: 'PowerOn Pipelines',
      tagline: 'CI/CD for Symitar',
      description:
        'Bring true continuous integration and deployment to your PowerOn development with automated validation, synchronization, and multi-stage deployments.',
      href: '/poweron-pipelines',
      status: 'Available',
      releaseYear: 2025,
    },
    {
      id: 'poweron-pro',
      name: 'PowerOn Pro',
      tagline: 'VS Code Extension for PowerOn',
      description:
        'Your complete development toolkit for PowerOn within Visual Studio Code. Equipped with a language server, direct Symitar integration, and powerful development tools.',
      href: '/poweron-pro',
      status: 'Available',
      releaseYear: 2024,
    },
    {
      id: 'nexum-api',
      name: 'NexumAPI',
      tagline: 'JSON-only interface for SymX',
      description:
        'A RESTful API that transforms SymXchange into a JSON-only, developer-friendly interface. Available as a language-agnostic service either self-hosted or managed by Libum.',
      href: '/nexum',
      status: 'Available',
      releaseYear: 2023,
    },
  ];

  return (
    <Container title={title} description={description} keywords={keywords} url={url} socialCard="libum">
      <div style={{ width: '100%' }}>
        <ContentPanel>
          <ContentHeadline>
            <h1>Products</h1>
            <p>
              Developer tools, RESTful APIs, and productivity software designed to transform how credit unions build and
              operate on the Jack Henry core.
            </p>
          </ContentHeadline>
        </ContentPanel>
        <ContentPanel>
          <ContentMain>
            <ProductsContainer>
              <ProductsGrid>
                {products.map((product) => (
                  <ProductCardWrapper key={product.id}>
                    <Link href={product.href} passHref legacyBehavior>
                      <ProductCard className={product.id}>
                        <ProductCardHeader>
                          <h2>{product.name}</h2>
                          <div className="tagline">{product.tagline}</div>
                        </ProductCardHeader>
                        <ProductCardBody>
                          <div className="meta">
                            <div className="status">
                              <div className={`dot ${product.status.toLowerCase().replace(' ', '-')}`} />
                              {product.status}
                            </div>
                            <div className="release">
                              <div className="dot release" />
                              {product.status === 'In Development' ? 'Coming in' : 'Released in'} {product.releaseYear}
                            </div>
                          </div>
                          <p>{product.description}</p>
                        </ProductCardBody>
                      </ProductCard>
                    </Link>
                  </ProductCardWrapper>
                ))}
              </ProductsGrid>
            </ProductsContainer>
          </ContentMain>
        </ContentPanel>
      </div>
    </Container>
  );
}
